

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface AdmissionMasterParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface AdmissionMaster {
  id?: any;
  admissionNumber?:any;
  regId: any; 
  ipNo:any;
  admissionDate:any;
  admissionType:any
  departmentId:any;
  physicianId:any;
  wardId: any;
  bedId: any;
  nursingCounterId: any;
  lockerNo: any;
  tenantId: any;
  branchId: any;
  admissionStatus:any;
  createdBy:any;
  createdDate:any;
  updatedBy:any;
  updatedDate:any;
  BedHouseKeepingMst?:Array<any>[]
  autoRoomRentServiceId?:string;
  autoRoomRentChargesFlag?:string;
  wardWisePriceSetting?:string;
  isIpBillGstInclusive?:string;
  allowGstInIpBill?:string;
  isIPAutoRoomRentPsoting?:boolean;
  TaxType?:string;
  parameters?: AdmissionMasterParameter[];
  links?: any;
  approvalDet?:any;
  approvalId? : any;
  visitId?:string;
  billingMode?: boolean;
  admissionMode?:string;
  admAdvId?:number;
  paymentMode?:number;
  secondaryConsultantId?: any;
  admissionSourceId?: any;
  payerId?: any;
  billingType?: any;
  reasonForAdmission?: any;
  expectedDischargeDate?: any;
  bedAllocationRemarks?: any;
  eligibleBedTypeId?: any;
  requestedBedTypeId?: any;
  allottedBedTypeId?: any;
  billableBedTypeId?: any;
  isSaudiBranch?:boolean;
  patientVat?:number;
  companyVat?:number;
  WardServiceRequest?:any;
}

export abstract class AdmissionMasterData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<AdmissionMaster[]>;
  abstract create(url: string, data: AdmissionMaster): Observable<AdmissionMaster[]>;
  abstract update(url: string, data: AdmissionMaster): Observable<AdmissionMaster>;
  abstract delete(url: string): Observable<any>;
 
}
